import { Container, Grid2, IconButton } from '@mui/material'
import styled from 'styled-components'

export const StyledGrid = styled(Grid2)`
  && {
    background-color: ${(props) => props.theme.colors.darkGray};
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`

export const StyledContainer = styled(Container)`
  && {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 75px;

    @media (min-width: 1440px) {
      max-width: 1400px;
    }
  }
`

export const StyledDivActions = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  @media (max-width: 600px) {
    gap: 16px;
  }

  @media (max-width: 470px) {
    gap: 8px;
  }
`

export const StyledButtonSearch = styled(IconButton)`
  && {
    color: ${(props) => props.theme.colors.white};

    svg {
      font-size: 28px;
    }
  }
`

export const StyledButtonSearchClose = styled(IconButton)`
  && {
    color: ${(props) => props.theme.colors.gray};

    svg {
      font-size: 28px;
    }
  }
`

export const StyledGroupSearchResponsive = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 20px;
`

export const StyledHeaderContent = styled.div`
  align-items: center;
  justify-content: space-between;
  width: 100%;
  transition:
    opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;
`

export const StyledHeaderLogoLocale = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const StyledHeaderLocale = styled(IconButton)`
  && {
    font-size: 18px;
    color: ${(props) => props.theme.colors.white};
  }
`

export const StyledButtonCampaign = styled.div`
  display: block;
  position: fixed;
  bottom: 65px;
  left: 10px;
`
